import type { ErrorTranslations } from "./utils";

export default {
  not_found: {
    EN: "Citizen not found",
    RO: "Cetățeanul nu a fost găsit",
  },
  already_linked_to_institution: {
    EN: "Citizen is already linked to an institution",
    RO: "Cetățeanul este deja asociat unei instituții",
  },
} satisfies ErrorTranslations;
